import React from 'react';
import { IonPage, IonContent, IonHeader, IonToolbar, IonBackButton, IonButtons, IonTitle, IonIcon } from '@ionic/react';
import { arrowBackOutline } from 'ionicons/icons';
import SearchIcon from '../../../shared/assets/icons/search.svg';
import BackButton from '../../../shared/assets/icons/back-button.svg';

import './AddFood.css'
type Dish = {
    id: number;
    name: string;
    desc: string;
    price: string;
    image: string;
};

type Category = {
    id: number;
    title: string;
    items: Dish[];
};

const categories: Category[] = [
    {
        id: 1,
        title: 'Пицца',
        items: [
            {
                id: 1,
                name: 'Маргарита',
                desc: 'Томаты, моцарелла, базилик',
                price: 'от 450 TJS',
                image: 'https://via.placeholder.com/80x80?text=Маргарита',
            },
            {
                id: 2,
                name: 'Пепперони',
                desc: 'Пепперони, моцарелла, томатный соус',
                price: 'от 520 TJS',
                image: 'https://via.placeholder.com/80x80?text=Пепперони',
            },
            {
                id: 3,
                name: 'Четыре сыра',
                desc: 'Моцарелла, горгонзола, пармезан, рикотта',
                price: 'от 580 TJS',
                image: 'https://via.placeholder.com/80x80?text=4сыра',
            },
        ],
    },
    {
        id: 2,
        title: 'Напитки',
        items: [
            {
                id: 4,
                name: 'Капучино',
                desc: 'Эспрессо с молочной пенкой',
                price: '125 TJS',
                image: 'https://via.placeholder.com/80x80?text=капучино',
            },
            {
                id: 5,
                name: 'Апельсиновый сок',
                desc: 'Свежевыжатый, тык',
                price: '85 TJS',
                image: 'https://via.placeholder.com/80x80?text=сок',
            },
        ],
    },
    {
        id: 3,
        title: 'Салаты',
        items: [
            {
                id: 6,
                name: 'Цезарь',
                desc: 'Салат, курица, пармезан, сухарики',
                price: '320 TJS',
                image: 'https://via.placeholder.com/80x80?text=Цезарь',
            },
            {
                id: 7,
                name: 'Греческий',
                desc: 'Помидоры, огурцы, фета, оливки',
                price: '280 TJS',
                image: 'https://via.placeholder.com/80x80?text=Греческий',
            },
        ],
    },
];

const AddFoods: React.FC = () => {
    const cartCount = 3;
    const cartTotal = '1 025 TJS';

    return (
        <IonPage>
            <IonHeader className="!bg-white second__toolbar">
                <IonToolbar className="px-3 ">
                    <IonTitle>Tab 1</IonTitle>
                    <IonButtons slot="start">
                        <IonBackButton text="" icon={BackButton}></IonBackButton>
                    </IonButtons>
                 
                </IonToolbar>
                <IonToolbar className="!border-none">
                       <div className=" mb-4 px-4 w-full top-[10%] left-[0px]">
                        <div className="flex items-center border border-[#E5E7EB] rounded-2xl bg-[#F9FAFB] px-3 py-2  h-[46px]">
                            <IonIcon src={SearchIcon} />
                            <input
                                type="text"
                                placeholder=" Поиск блюд..."
                                className="w-full border-none bg-transparent text-sm outline-none placeholder:text-slate-400"
                            />
                        </div>
                    </div>
                </IonToolbar>
            </IonHeader>
            <IonContent className="bg-slate-100">
                <div className="mx-auto flex h-full max-w-md flex-col pt-3 mb-60">
                    <div className="flex-1 space-y-4 mb-30">
                        {categories.map((cat) => (
                            <div key={cat.id}>
                                <h3 className="mb-2 text-sm font-semibold text-slate-800">
                                    {cat.title}
                                </h3>

                                <div className="space-y-2">
                                    {cat.items.map((dish) => (
                                        <div
                                            key={dish.id}
                                            className="flex items-end justify-between rounded-2xl bg-white px-3 py-3 shadow-sm"
                                        >
                                            <div className="flex flex-1 items-center gap-3">
                                                <img
                                                    src={dish.image}
                                                    alt={dish.name}
                                                    className="h-16 w-16 rounded-xl object-cover"
                                                />
                                                <div>
                                                    <div className="text-sm font-semibold text-slate-900">
                                                        {dish.name}
                                                    </div>
                                                    <div className="mt-1 text-[11px] text-slate-500">
                                                        {dish.desc}
                                                    </div>
                                                    <div className="mt-1 text-xs font-semibold text-slate-800">
                                                        {dish.price}
                                                    </div>
                                                </div>
                                            </div>

                                            <button
                                                className="h-[28px] ml-2 flex items-center rounded-lg bg-[#3B82F6] px-3 py-2 text-xs font-semibold text-white shadow-sm hover:bg-blue-700"
                                            >
                                                <span className="mr-1 text-base">＋</span>
                                                <span>Добавить</span>
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* нижняя панель корзины */}
                    <div className="pointer-events-none fixed bottom-0 left-0 right-0 flex justify-center !bg-red-400">
                        <div className="pointer-events-auto  w-full max-w-md  bg-white px-3 pt-2 pb-3 ">
                            <div className="mb-2 flex items-center justify-between text-xs">
                                <div className="flex items-center gap-2">
                                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-blue-600 text-[11px] font-semibold text-white">
                                        {cartCount}
                                    </span>
                                    <span className="text-slate-600">Товаров в корзине</span>
                                </div>
                                <span className="text-sm font-semibold text-slate-900">
                                    {cartTotal}
                                </span>
                            </div>

                            <div className="flex gap-2 text-xs">
                                <button className="flex-1 rounded-xl bg-[#F3F4F6] h-[44px] border border-slate-300 py-2 font-medium text-slate-700">
                                    Очистить
                                </button>
                                <button className="flex-1 rounded-xl bg-[#3B82F6]  h-[44px] py-2 font-medium text-white">
                                    Добавить к столу
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default AddFoods;
